import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Button,
  Checkbox,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { SiTrackGrid } from '../../components/si-track-grid/si-track-grid';
import { Service } from '../../models/masters/service';
import { useLoadData } from '../../hooks/useLoadData';
import { ApiResponse } from '../../models/api-response';
import { QueryKeyConfig } from '../../api/api-helper';
import { servicesColumns } from './grid-columns';
import { GridCellProps, GridRowProps } from '@progress/kendo-react-grid';
import { UserPermissionName } from '../../models/user-permission-name';
import { useAuthorize } from '../../hooks/use-authorize';

const SELECTED_FIELD = 'isSelected';
const styling = {
  dialogTitleStyle: { padding: '16px 24px 0' },
  contentPadding: { paddingTop: '30px' },
  buttonPadding: { paddingTop: '20px' },
  tabHeading: { fontWeight: 'bold' },
  buttonStyle: { width: '130px' },
};

interface ContactsDialogProps {
  servicesApiQuery: () => QueryKeyConfig;
  open: boolean;
  isNotReadyService?: boolean;
  selectedField?: string;
  isShowUncheckConfirmation?: boolean;
  services: Service[];
  onClose: (contracts: Service[]) => void;
  handleCancelClick?: () => void;
  preventCheckAndUnCheckOnHeaderelectionChange?: any[];
  conditionalCellRender?: (
    defaultRendering: React.ReactElement<HTMLTableCellElement> | null,
    props: GridCellProps
  ) => React.ReactElement<HTMLTableCellElement> | React.ReactElement<HTMLTableCellElement>[] | null;
}

const DEFAULT_GROUP = [
  {
    field: 'serviceGroupName',
  },
];

export const SelectServicesDialog = ({
  open,
  services,
  servicesApiQuery,
  onClose,
  handleCancelClick,
  selectedField,
  conditionalCellRender,
  isShowUncheckConfirmation,
  isNotReadyService,
  preventCheckAndUnCheckOnHeaderelectionChange,
}: ContactsDialogProps) => {

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  const [selectedServices, setSelectedServices] = useState<Service[]>(services ?? []);
  const [completeData, setCompleteData] = useState<Service[]>();

  const { data, isLoading } = useLoadData<ApiResponse<Service[]>>(servicesApiQuery());

  useEffect(() => {
    if (data) {
      const updatedData = data?.data.map((d) => ({
        ...d,
        isSelected: services.some((s) => s.serviceID === d.serviceID),
      }));
      setCompleteData(updatedData);
      // setSelectedServices(updatedData?.filter((d: any) => d.isSelected) ?? []);
    }
  }, [data]);

  const handleSelectedItem = (values: Service[], isChecked: boolean) => {
    if (isChecked) {
      const data = completeData?.reduce((result: Service[], service: Service) => {
        const isSelected = values.some((v) => {
          //const predecessorServiceIDs = v.predecessorServiceIDs?.split(',').map(Number);
          return v.serviceID === service.serviceID //|| predecessorServiceIDs?.includes(service.serviceID);
        });
        return [...result, { ...service, isSelected }];
      }, []);

      setSelectedServices(data?.filter((d: any) => d.isSelected) ?? []);
      setCompleteData(data);
    } else {
      const data = completeData?.reduce((result: Service[], service: Service) => {
        const isSelected = values.some((v) => {
          return v.serviceID === service.serviceID;
        });
        return [...result, { ...service, isSelected }];
      }, []);

      setSelectedServices(data?.filter((d: any) => d.isSelected) ?? []);
      setCompleteData(data);
    }
  };

  const handleDialogClose = () => {
    onClose(selectedServices);
  };

  const handleClose = () => {
    handleCancelClick?.();
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={'xl'}
      // onClose={handleClose}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="dialog-title" style={styling.dialogTitleStyle}>
        SELECT SERVICE
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 10,
          top: 3,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers style={styling.contentPadding} className="popupDilog">
        <Grid>
          <SiTrackGrid
            fileTitle='customer_service'
            dataItems={!isNotReadyService ? completeData : completeData?.filter((d: Service) => !d.isNotReadyService)}
            // selectedField="isSelected"
            selectedField={selectedField}
            dataItemKey="serviceID"
            columns={servicesColumns}
            onSelectedItems={handleSelectedItem}
            isShowUncheckConfirmation={isShowUncheckConfirmation}
            preventCheckAndUnCheckOnHeaderelectionChange={preventCheckAndUnCheckOnHeaderelectionChange}
            isBusy={isLoading}
            // isDiableHeaderCell={true}
            // defaultGroup={DEFAULT_GROUP}
            conditionalCellRender={conditionalCellRender}
            actionPermissions={{
              export: UserPermissionName.DOWNLOAD_GRID,
            }}
          />
          <Grid item>
            <div className="popupFooter alignRight">
              <Button
                type={'submit'}
                variant="contained"
                disableElevation={true}
                style={styling.buttonStyle}
                disabled={isLoading || isReadOnlyPermission}
                onClick={handleDialogClose}
              >
                OK
              </Button>
            </div>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
